import { Stack } from "@mui/material";
import { Fragment } from "react";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { ChatPushDeviceSettingsRow } from "Components/Settings/ChatPushDeviceSettingsRow";
import { SettingsItem } from "Components/Settings/SettingsItem/SettingsItem";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useSettingsMenu } from "Hooks/Layout/useSettingsMenu";
import { Resources, useResource } from "Translations/Resources";
import { isNativePlatform } from "Utils/Platform/PlatformUtils";
import { appUrl } from "Utils/UrlUtils";

export const SettingsPage = () => {
  const settingsLinks = useSettingsMenu();
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.Settings)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null, // "root" page, nowhere higher to go
      }}
    >
      <StyledPageWrapper>
        <Stack className="left-content">
          {settingsLinks.map((link) => (
            <Fragment key={link.text}>
              <SettingsItem link={link} />
              {/* Device-level chat push opt-in sits right under the Chat entry; native shells only. */}
              {isNativePlatform() && link.url === appUrl("chat") && (
                <ChatPushDeviceSettingsRow />
              )}
            </Fragment>
          ))}
        </Stack>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default SettingsPage;
